export default __webpack_public_path__ + "static/ADOT-design-33fe763882d014e4be38457a14028def.png";